import React from "react";
import Table2CellContainer from "./Table2Cell/Table2Cell/Table2CellContainer";
import Table2EditorOps from "au.com.easil.table2editorops";
import { Flipped } from "react-flip-toolkit";

const Table2Row = ({
  row,
  rowIndex,
  elementData,
  isPreview,
  pageId,
  zoom,
  lockedRowResizeCellIds,
  lockedColumnResizeCellIds
}) => {
  const table2EditorOps = new Table2EditorOps(elementData.layout);
  // Use first cell's ID as row identifier for stable flip animations
  // This ensures the row maintains its identity across reorders
  const rowFlipId = `table-row-${elementData.uniqueId}-${row[0].id}`;

  return (
    <Flipped flipId={rowFlipId}>
      <tr key={rowIndex}>
        {row.map(({ coordinates, id }, columnIndex) => {
          const isReferenceCell =
            rowIndex !== coordinates[0] || columnIndex !== coordinates[1];
          if (!isReferenceCell) {
            const rowSpan = table2EditorOps.computeRowSpan(
              rowIndex,
              columnIndex
            );
            const colSpan = table2EditorOps.computeColSpan(
              rowIndex,
              columnIndex
            );
            // Pass flipId to cell for column reordering animations
            const cellFlipId = `table-cell-${elementData.uniqueId}-${id}`;
            return (
              <Table2CellContainer
                key={id}
                flipId={cellFlipId}
                colSpan={colSpan}
                rowSpan={rowSpan}
                rowIndex={rowIndex}
                columnIndex={columnIndex}
                cellId={id}
                elementData={elementData}
                isPreview={isPreview}
                pageId={pageId}
                zoom={zoom}
                lockedRowResizeCellIds={lockedRowResizeCellIds}
                lockedColumnResizeCellIds={lockedColumnResizeCellIds}
              />
            );
          } else {
            return null;
          }
        })}
      </tr>
    </Flipped>
  );
};

export default Table2Row;
